<script>
import { Doughnut, mixins } from "vue-chartjs";
import chartMixins from "./chartMixin";

const { reactiveProp } = mixins;
export default {
	extends: Doughnut,
	mixins: [chartMixins, reactiveProp],
	props: {},
	computed: {
		options() {
			return {
				legend: {
					position: "bottom",
					labels: {
						fontSize: 13
					}
				},
				tooltips: {
					enabled: this.showTooltip,
					callbacks: {
						title: (tooltipItem, data) => {
							return data["labels"][tooltipItem[0]["index"]];
						},
						label: (tooltipItem, graphData) => {
							const { data } = graphData.datasets[0];
							return `${data[tooltipItem.index]}${this.prependTooltip}`;
						}
					}
				}
			};
		}
	},
	mounted() {
		this.renderChart(this.chartData, this.options);
	}
};
</script>
